module.exports = __webpack_public_path__ + "static/img/pete_profile_800x700.dda0376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_profile_800x700.jpg
// module id = D1Hb
// module chunks = 0